import React from "react";

export default {
  'TimeInput.Wrapper.HourWrapper.Input(Keydown)': ({ value, minute, ampm, key }, outlet, internalStateSetter) => {
  },
  'TimeInput.Wrapper.HourWrapper.Input': async ({ value, minute, ampm, minuteInputRef }, outlet, internalStateSetter) => {
    let val = value;

    let ref = minuteInputRef;
    if (!minuteInputRef) {
      ref = React.createRef();
      await internalStateSetter({ minuteInputRef: ref })
    }

    if (/^\d{1,2}$/.test(value)) {
      const numValue = parseInt(value, 10);
      if (numValue < 0 || numValue > 12) {
        val = '';
      } else if (value.length === 1 && value !== '0' && value !== '1') {
        val = '0' + value;
      }
    } else {
      val = '';
    }

    if (val.length === 2) {
      ref?.current?.children[0]?.children[0]?.focus();
    }

    internalStateSetter({ hour: val });

    if (val && minute) {
      outlet({ selectedOptionId: `${val}:${minute} ${ampm}` })
    }
  },
  'TimeInput.Wrapper.MinuteWrapper.Input(Keydown)': async ({ value, minute, ampm, key, hourInputRef }, outlet, internalStateSetter) => {

    let ref = hourInputRef;
    if (!hourInputRef) {
      ref = React.createRef();
      await internalStateSetter({ hourInputRef: ref })
    }

    if (key === 'Backspace' && value === '') {
      ref?.current?.children[0]?.children[0]?.focus();
    }
  },
  'TimeInput.Wrapper.MinuteWrapper.Input': async ({ value, hour, ampm }, outlet, internalStateSetter) => {
    let val = value;

    if (/^\d{1,2}$/.test(value)) {
      const numValue = parseInt(value, 10);
      if (numValue < 0 || numValue > 59) {
        val = '';
      } else if (value.length === 1 && numValue > 5) {
        val = '0' + value;
      }
    } else {
      val = '';
    }

    internalStateSetter({ minute: val });
    if (val && hour) {
      outlet({ selectedOptionId: `${hour}:${val} ${ampm}` })
    }
  },
  'TimeInput.Wrapper.AMPMDropdown': ({ selectedOptionId, hour, minute }, outlet, internalStateSetter) => {
    internalStateSetter({ ampm: selectedOptionId })

    if (hour && minute) {
      outlet({ selectedOptionId: `${hour}:${minute} ${selectedOptionId}` })
    }
  }
}
